import styled from "styled-components";

export const Container = styled.div`
  max-width: 600px;

  .buttons {
    padding-right: 20px;

    button {
      background: #eee;
      border: none;
      outline: none;
      padding: 5px 10px;
      cursor: pointer;

      &:nth-child(2) {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        /* border-radius: 4px 0 0 4px; */
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        /* border-radius: 0 4px 4px 0; */
      }

      &.selected {
        background: #41a8bf;
        color: #fff;
        font-weight: bold;
      }
    }

    p {
      margin: 0 0 5px 0;
    }
  }

  .flex-end {
    display: flex;
    justify-content: flex-end;
  }

  .btn-clear {
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    padding: 10px;

    svg {
      height: 18px;
      width: 18px;
    }
  }
`;
